import ProductAction from '../../prat_actions/gt/productAction'

const ProductReducer = (state = {
    isProductLoading: true, isCategoryLoading: false, isBrandsLoading: false,
    isSkusLoading: false, isMasterSkusLoading: false, isProductSectorsLoading: false,
    isProductSectorsHasError: true
}, action) => {
    switch (action.type) {
        // product division

        case ProductAction.PRODUCT_DEVISIONS_REQUEST:
            return {
                ...state,
                isDivisionLoading: true,
            };

        case ProductAction.PRODUCT_DEVISIONS_SUCCESS:
            return {
                ...state,
                isDivisionLoading: false,
                productDevisions: action.data
            };

        case ProductAction.PRODUCT_DEVISIONS_FAILED:
            return {
                ...state,
                isDivisionLoading: false,
                error: action.error
            };

        // SBB TYPE 

        case ProductAction.SBB_TYPE_REQUEST:
            return {
                ...state,
                isSbbTypeLoading: true,
            };

        case ProductAction.SBB_TYPE_SUCCESS:
            return {
                ...state,
                isSbbTypeLoading: false,
                sbb_type: action.data
            };

        case ProductAction.SBB_TYPE_FAILED:
            return {
                ...state,
                isSbbTypeLoading: false,
                error: action.error
            };


        //PRODUCT CUSTOMER

        case ProductAction.PRODUCT_CUSTOMER_REQUEST:
            return {
                ...state,
                isProductLoading: false,
            };

        case ProductAction.PRODUCT_CUSTOMER_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productCustomer: action.data
            };

        case ProductAction.PRODUCT_CUSTOMER_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error
            };

        // PRODUCT CATEGORIES

        case ProductAction.PRODUCT_CATEGORIES_REQUEST:
            return {
                ...state,
                isProductLoading: false,
                isCategoryLoading: true
            };

        case ProductAction.PRODUCT_CATEGORIES_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productCategories: action.data,
                isCategoryLoading: false
            };

        case ProductAction.PRODUCT_CATEGORIES_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error,
                isCategoryLoading: false
            };

        // PRODUCT BRANDS

        case ProductAction.PRODUCT_BRANDS_REQUEST:
            return {
                ...state,
                isProductLoading: false,
                isBrandsLoading: true
            };

        case ProductAction.PRODUCT_BRANDS_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productBrands: action.data,
                isBrandsLoading: false
            };

        case ProductAction.PRODUCT_BRANDS_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error,
                isBrandsLoading: false
            };

        // PRODUCT SKUS

        case ProductAction.PRODUCT_SKUS_REQUEST:
            return {
                ...state,
                isProductLoading: false,
                isSkusLoading: true
            };

        case ProductAction.PRODUCT_SKUS_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productSkus: action.data,
                isSkusLoading: false
            };

        case ProductAction.PRODUCT_SKUS_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error,
                isSkusLoading: false
            };

        // PRODUCT MASTER SKUS

        case ProductAction.PRODUCT_MASTER_SKUS_REQUEST:
            return {
                ...state,
                isProductLoading: false,
                isMasterSkusLoading: true
            };

        case ProductAction.PRODUCT_MASTER_SKUS_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productMasterSkus: action.data,
                isMasterSkusLoading: false
            };

        case ProductAction.PRODUCT_MASTER_SKUS_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error,
                isMasterSkusLoading: false
            };

        // PRODUCT VARIANTS

        case ProductAction.PRODUCT_VARIANTS_REQUEST:
            return {
                ...state,
                isProductLoading: false,
            };

        case ProductAction.PRODUCT_VARIANTS_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productVariants: action.data
            };

        case ProductAction.PRODUCT_VARIANTS_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error
            };

        // PRODUCT FORMATS

        case ProductAction.PRODUCT_FORMATS_REQUEST:
            return {
                ...state,
                isProductLoading: false,
            };

        case ProductAction.PRODUCT_FORMATS_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                producFormats: action.data
            };

        case ProductAction.PRODUCT_FORMATS_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error
            };

        //PEODUCT SIZE

        case ProductAction.PRODUCT_SIZE_REQUEST:
            return {
                ...state,
                isProductLoading: false,
            };

        case ProductAction.PRODUCT_SIZE_SUCCESS:
            return {
                ...state,
                isProductLoading: false,
                productSize: action.data
            };

        case ProductAction.PRODUCT_SIZE_FAILED:
            return {
                ...state,
                isProductLoading: false,
                error: action.error
            };


        // ACTIVITY END STOCK
        case ProductAction.ACTIVITY_END_STOCK_REQUEST:
            return {
                ...state,
                isActivityEndStockLoading: true,
            };

        case ProductAction.ACTIVITY_END_STOCK_SUCCESS:
            return {
                ...state,
                isActivityEndStockLoading: false,
                activityEndStock: (() => {
                    if (action.page === 1) {
                        return action.data
                    }
                    return {
                        ...state.activityEndStock,
                        results: [
                            ...state.activityEndStock.results,
                            ...action.data.results
                        ]
                    }
                })()
            };

        case ProductAction.ACTIVITY_END_STOCK_FAILED:
            return {
                ...state,
                isActivityEndStockLoading: false,
                error: action.error
            };

        // PRODUCT SECTORS
        case ProductAction.PRODUCT_SECTORS_REQUEST:
            return {
                ...state,
                productSectors: null,
                isProductSectorsLoading: true,
                isProductSectorsHasError: false
            };

        case ProductAction.PRODUCT_SECTORS_SUCCESS:
            return {
                ...state,
                productSectors: action.data,
                isProductSectorsLoading: false,
                isProductSectorsHasError: false
            };

        case ProductAction.PRODUCT_SECTORS_FAILED:
            return {
                ...state,
                productSectors: null,
                isProductSectorsLoading: false,
                isProductSectorsHasError: true
            };


        default:
            return {
                ...state
            };
    }
}

export default ProductReducer;